import React, { useState, useEffect } from 'react'; 
import { NavLink, useNavigate } from "react-router-dom";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
import swal from "sweetalert";
import axios from "axios";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export default function Userslist() {
  const nav = useNavigate();
  const [users, setUsers] = useState([]);
  const [dashboardData, setDashboardData] = useState({});
  useEffect(() => {
    getUsers();
    getDashBoardData();
  }, []);

  const getUsers = async () => {
    await axios
      .get(process.env.REACT_APP_API_KEY + "api/admin/users-latest",
      {
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      })
      .then(function (response) {  
        //Check for Authorized
        if(response.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }
          setUsers(response.data);      
      })
      .catch(function (error) {
        console.log("error=>", error)        
        console.log(error);
      });
  };

  const getDashBoardData = async () => {
    await axios
      .get(process.env.REACT_APP_API_KEY + "api/admin/dashboard-data",
      {
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      })
      .then(function (response) {  
        //Check for Authorized
        if(response.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }
          setDashboardData(response.data);
      })
      .catch(function (error) {
        console.log("error=>", error)        
        console.log(error);
      });
  };


  return (
    <div class="body flex-grow-1 px-3">
          <div className="wrapper">
          
      <div className="content-wrapper">
      <div className='user-counter-box '>
        <div className="user-counter bg-primary" >
          <span>Total Registered User</span>
          <span className='counter-num '>{dashboardData.user_count}</span> 
        </div>
        <div className="user-counter bg-success" >
          <span>Total Email Templates</span>
          <span className='counter-num'>{dashboardData.email_count}</span> 
        </div>
        <div className="user-counter bg-info" >
          <span>Total Static Pages</span>
          <span className='counter-num'>{dashboardData.staticContent_count}</span> 
        </div>
        <div className="user-counter bg-danger" >
          <span>Total FAQ's</span>
          <span className='counter-num'>{dashboardData.faq_count}</span> 
        </div>
      </div>
      

      <h5 className="my3">
        Latest 5 registered users
      </h5>
      <table id="myTable" className="table table-striped my-3">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" style={{"width" : "20%"}}>Name</th>
            <th scope="col" style={{"width" : "30%"}}>Email</th>
            <th scope="col">Contact</th>
            <th scope="col">Role</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user.id}>
              <td>{++index}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.phone_number}</td>
              <td>{user.role_type}</td>
              <td>{user.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div> 
          </div>
  )
}